<template>
  <v-container class="py-6">
    <v-card elevation="2">
      <v-card-title class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon icon="mdi-timer" class="me-2" />
          <span>Frontend Metrics (feMetrics)</span>
        </div>
        <div class="d-flex align-center gap-2">
          <v-btn size="small" variant="outlined" color="primary" @click="refresh">Refrescar</v-btn>
          <v-btn size="small" variant="outlined" color="secondary" @click="exportJson" :disabled="!events.length">Exportar JSON</v-btn>
          <v-btn size="small" variant="outlined" color="error" @click="clearAll" :disabled="!events.length">Limpiar</v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div v-if="!events.length" class="text-medium-emphasis">Sin eventos aún. Navega por la app para generar métricas.</div>
        <v-table v-else density="comfortable">
          <thead>
            <tr>
              <th style="width: 160px;">Hora</th>
              <th style="width: 200px;">Evento</th>
              <th>Datos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(e, idx) in events" :key="idx">
              <td>{{ formatTs(e.ts) }}</td>
              <td><v-chip size="small" color="blue" variant="outlined">{{ e.name }}</v-chip></td>
              <td><pre class="mb-0">{{ pretty(e.data) }}</pre></td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
  </v-container>
  
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import feMetrics from '@/services/fe-metrics'

type MetricEvent = { name: string; ts: number; data?: Record<string, any> }

const events = ref<MetricEvent[]>([])

const refresh = () => {
  // Copia superficial para evitar mutaciones reactivas accidentales
  events.value = [...feMetrics.recent]
}

const clearAll = () => {
  feMetrics.clear()
  refresh()
}

const exportJson = () => {
  const blob = new Blob([JSON.stringify(events.value, null, 2)], { type: 'application/json' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = `fe-metrics-${Date.now()}.json`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

const formatTs = (ts: number) => new Date(ts).toLocaleTimeString()
const pretty = (obj: any) => obj ? JSON.stringify(obj, null, 2) : ''

onMounted(refresh)
</script>

<style scoped>
pre { 
  white-space: pre-wrap; 
  font-size: 12px; 
  background: #f8f9fb; 
  padding: 8px; 
  border-radius: 6px;
}
.gap-2 > * + * { margin-left: 8px; }
</style>
